import VariableEditForm from "./variable-edit-form";

export default VariableEditForm;